$(() => {
    $('.js_component_filter').on('submit', function (e) {
        $(this)
            .find('input[name], select[name]')
            .filter(function () {
                return !this.value;
            })
            .prop('name', '');
    });
});

/**
 * Dynamic filters
 */

$(() => {
    const $filterType = $('.js_component_filter_item_type .js_component_select_multiple');
    
    $filterType.on('change', () => updateFilters());

    const updateFilters = () => {
        /**
         * Show/hide dynamic filters by "log type"
         */
        const value = $filterType.val();

        if (!_.isEmpty(value)) {
            $('.js_component_filter_item').each((index, item) => {
                const $item = $(item);
        
                if (value.indexOf($item.data('filter-type')) !== -1) {
                    $item.show();
                } else {
                    $item.hide();
                }
            });
        }
    };

    updateFilters();
});